import { render } from "./ModalKuis.vue?vue&type=template&id=797a2246"
import script from "./ModalKuis.vue?vue&type=script&lang=js"
export * from "./ModalKuis.vue?vue&type=script&lang=js"
script.render = render

export default script